import { Radio, Typography } from "antd";
import { AnswersPros } from "./survey-answers-content";
import { convertQuillToString } from "../../../../../../../utils/convertQuillToString";

const Connect = (props: AnswersPros) => {
const { question } = props;
  return <div className='survey-answers-content__wrapper'>
    <div className='survey-answers-content__title'>
      <Typography.Title level={3}>{convertQuillToString(question.question)}</Typography.Title>
    </div>
    <div className='survey-answers-content__body'>
      {question.answers.map((x: any, i: number) => {
        return <div key={i + 1} className='survey-answers-content__body__item'>
          <div className='item__action'>
            <Radio checked={x.isTrue} disabled></Radio>
          </div>
          <div className='item__action'>
            {convertQuillToString(x.content)}
          </div>
        </div>
      })}
    </div>
  </div>
}

export default Connect;